module.exports = __webpack_public_path__ + "static/img/4.2708ffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/03/4.png
// module id = Bxs5
// module chunks = 1